import { fetcher } from '@commenda/utils';
import { TEMPLATES_URL } from './helpers';
import { TDocumentAssemblerCreateTemplateParams } from './types';

export const createDocumentAssemblerTemplate = async (
  data: TDocumentAssemblerCreateTemplateParams
): Promise<Response> => {
  const res = await fetcher(TEMPLATES_URL, { method: 'POST', body: data });
  return res;
};
